import React, { useEffect, useState } from "react";

import { logoSrc } from "services/transportadoraLogoApi";

// Identidade visual da transportadora (H1/H2, PO1-2620 → PO1-2722). Com
// `logoUrl` mostra o logo real numa caixa quadrada de fundo branco fixo — logo
// de terceiro vem em cor chapada e some no tema escuro do Hub (decisão 7 do
// gate). Sem logo, ou se a imagem falhar ao carregar, cai no monograma: as
// iniciais da fantasia/razão social num círculo, cor derivada do nome
// (determinística, sem estado). Os dois convivem no mesmo grid por muito tempo.
// PO1-2726: cores por token (status/accent), fundo e borda via color-mix, para
// acompanhar tema claro/escuro e a cor de destaque.
const TONES = [
  "var(--everlog-status-info)",
  "var(--everlog-status-success)",
  "var(--everlog-status-danger)",
  "var(--everlog-status-warning)",
  "var(--everlog-status-accent)",
];

function corPara(nome) {
  const s = String(nome || "");
  let hash = 0;
  for (let i = 0; i < s.length; i += 1) hash = (hash * 31 + s.charCodeAt(i)) % TONES.length;
  return TONES[Math.abs(hash) % TONES.length];
}

function iniciais(nome) {
  const partes = String(nome || "?").trim().split(/\s+/).filter(Boolean);
  if (!partes.length) return "?";
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[1][0]).toUpperCase();
}

export default function TransportadoraMonogram({ nome, size = 32, logoUrl }) {
  const [falhou, setFalhou] = useState(false);
  useEffect(() => {
    setFalhou(false);
  }, [logoUrl]);

  const src = logoUrl && !falhou ? logoSrc(logoUrl) : null;
  if (src) {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: Math.max(6, Math.round(size * 0.28)),
          background: "#ffffff", // theme-ok: fundo branco fixo atrás de logo de terceiro (PO1-2722, decisão 7)
          border: "1px solid var(--everlog-card-border-faint)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          overflow: "hidden",
          padding: Math.max(2, Math.round(size * 0.1)),
          boxSizing: "border-box",
        }}
      >
        <img
          src={src}
          alt={`Logo de ${nome || "transportadora"}`}
          onError={() => setFalhou(true)}
          style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }}
        />
      </div>
    );
  }

  const cor = corPara(nome);
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        background: `color-mix(in srgb, ${cor} 15%, transparent)`,
        border: `1px solid color-mix(in srgb, ${cor} 40%, transparent)`,
        color: cor,
        fontSize: size * 0.38,
        fontWeight: 700,
      }}
      aria-hidden="true"
    >
      {iniciais(nome)}
    </div>
  );
}
